
import {$array, $idSeed} from "@util/util.js";
import Sku from "@core/Sku.js";

export default class Additional extends Sku {
    constructor(){
        super();

        this._data = null;

        this.__tempId = $idSeed.newId();
        this._additionalName = "";
        this._additionalType = -1;
        this._dataSource = [];
        this._items = [];
        this._parent = null;
    }

    init(data){
        
    }

    setParent(parent){
        this._parent = parent;
    }

    addItem(item){
        this._items.push(item);
    }

    removeItem(item){
        this._items = $array.removeItem(this._items, {id:item._id});
    }
}